<template>
  <LayoutChallenge
    :lessonName="lesson.name"
    :stepCount="this.steps.length"
    :currentStep="step"
    v-on:backClick="handleClickBack"
    v-on:closeClick="handleClickClose"
    v-on:nextClick="handleClickNextStep"
    @answerQuiz="handleAnswerQuiz"
  >
    <div class="flex flex-col">
      <h1 class="mx-2 mt-0 text-center text-lg">{{ this.lesson.name }}</h1>
      <span class=" text-center text-white text-xs px-2 py-1 mb-3 mt-1">
        <span
          v-if="discipline"
          class="px-2 py-1 rounded-full"
          :style="{ backgroundColor: discipline.hex_color }"
        >
          {{ discipline.name }}</span
        >
      </span>

      <div class="mb-5">
        <div class="flex-1">
          <LessonText
            class=""
            v-if="currentContent && currentContent.type === 'text'"
            :text="currentContent.text_body"
            :title="currentContent.name"
          ></LessonText>
          <quiz
            v-if="currentContent && currentContent.type === 'quiz'"
            class="quiz mx-2"
            :current-content="currentContent"
            @answerQuiz="handleCompletedQuiz"
            @clickedPlaceholder="handleClickQuiz"
            @clickedAlternative="handleClickQuiz"
            @clickedTryAgain="handleClickQuiz"
            ref="quiz"
          />
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <QuizAnswerButton
        :visible="currentContent && currentContent.type === 'quiz'"
        :disabled="!answerQuizEnabled"
        @clickedButton="handleAnswerQuiz"
      />
      <button @click="handleClickNextStep" class="button button-primary mt-4">
        Próxima
      </button>
    </template>
  </LayoutChallenge>
</template>

<script>
import LayoutChallenge from "../layouts/LayoutChallenge.vue";
import Quiz from "../components/Quiz.vue";
import axios from "../axiosClient";
import LessonText from "../components/LessonText";
import QuizAnswerButton from "../components/QuizAnswerButton";

export default {
  name: "Lesson",
  data() {
    return {
      step: 1,
      steps: [],
      challengeIdFromRoute: "",
      challenge: {},
      lesson: "",
      lessonNumber: "",
      urlPath: "/desafio",
      actionName: "fetchLastChallenge",
      answerQuizEnabled: false
    };
  },
  components: {
    LayoutChallenge,
    quiz: Quiz,
    LessonText,
    QuizAnswerButton
  },

  computed: {
    currentContent: function() {
      return this.steps.find(content => {
        return content.step == this.step;
      });
    },
    discipline: function() {
      if (this.lesson.discipline) {
        return this.lesson.discipline;
      }
      return null;
    }
  },
  methods: {
    handleAnswerQuiz() {
      this.$refs.quiz.answerQuiz();
      this.answerQuizEnabled = false; // para desabilitar
    },
    handleClickQuiz(spots) {
      this.answerQuizEnabled = !spots.some(spot => spot === "???");
    },

    handleClickNextStep() {
      this.updateLesson(); // isso faz com que não dê erro de nao aparecer alternativas quando user responde, sai e volta no quiz.
      this.step = this.step + 1;

      //Vamos marcar como concluído o content anterior, se não há quiz. Porque se há, quem vai marcar é o componente quiz.
      this.setPreviousStepContentCompleteIfThereIsNoQuiz();

      //acabou a lesson. Se ele completou, vamos mandar para a completed. Se não, vamos mandar pro desafio.
      if (this.step > this.steps.length) {
        this.handleClickLastStep();
      }
    },

    handleClickLastStep() {
      this.step = 1; // resetamos a step.

      // Nesse método vamos ver se o usuário
      this.$store
        .dispatch(this.actionName, this.challengeIdFromRoute)
        .then(() => {
          if (this.challengeIdFromRoute) {
            this.challenge = this.$store.state.selectedChallenge;
          } else {
            this.challenge = this.$store.state.lastChallenge;
          }
          this.lesson = this.challenge.lessons[this.$route.params.number - 1];

          // vamos ver se ele acabou a lição  ou não.
          if (!this.userCompletedLesson()) {
            this.$router.push(this.urlPath);
          } else {
            this.$router.push(
              `${this.urlPath}/aula/${this.$route.params.number}/completed`
            );
          }
        })
        .catch();
    },

    userCompletedLesson() {
      return this.lesson.contents.every(content => {
        return content.completed_at;
      });
    },

    handleClickBack() {
      this.updateLesson(); // isso faz com que não dê erro de nao aparecer alternativas quando user responde, sai e volta no quiz.

      (this.stepBack = true), (this.step = this.step - 1);
      this.stepBack = false;

      // Adicionar classe transition.

      if (this.step < 1) {
        this.$router.push(this.urlPath);
      }
    },
    handleClickClose() {
      this.$router.push(this.urlPath);
    },
    handleCompletedQuiz(payload) {
      this.setContentComplete(this.currentContent.contentId, payload);
    },

    setPreviousStepContentCompleteIfThereIsNoQuiz() {
      if (this.step === 1) return; // se estamos na primeira step, nada a fazer.

      const previousStepContentId = this.steps.find(content => {
        return content.step == this.step - 1;
      }).contentId;

      // Vamos pegar o previous content da lista de steps.
      const contentToComplete = this.lesson.contents.find(content => {
        return content.id === previousStepContentId;
      });

      // Se não há quiz_question, podemos marcar como concluído. Se há, o component quiz vai fazer isso.
      if (!contentToComplete.quiz_question) {
        this.setContentComplete(previousStepContentId, {
          answered_alternatives: [],
          is_correct: null
        });
      }
    },
    setContentComplete(contentId, payload) {
      axios.post(`contents/${contentId}/complete`, payload).then(() => {
        // marca como completo os steps.
        this.steps = this.steps.map(step => {
          return {
            ...step,
            completed: contentId == step.contentId ? true : step.completed
          };
        });
        this.$store.dispatch(this.actionName, this.challengeIdFromRoute);
      });
    },
    mountSteps() {
      const contentArray = [];
      let stepCounter = 1;

      // vamos criar o array de Steps, marcando
      this.lesson.contents.forEach(content => {
        if (content.text_body) {
          contentArray.push({
            contentId: content.id,
            name: content.name,
            type: "text",
            step: stepCounter,
            text_body: content.text_body,
            completed: content.completed_at ? true : false
          });
          stepCounter++;
        }
        if (content.quiz_question) {
          contentArray.push({
            contentId: content.id,
            name: content.name,
            type: "quiz",
            step: stepCounter,
            quiz_question: content.quiz_question,
            quiz_alternatives: content.quiz_alternatives,
            completed: content.completed_at ? true : false,
            answered_alternatives: content.completed_at
              ? content.answered_alternatives
              : false
          });
          stepCounter++;
        }
      });

      this.steps = contentArray;
    },
    updateLesson() {
      return this.$store
        .dispatch(this.actionName, this.challengeIdFromRoute)
        .then(() => {
          if (this.challengeIdFromRoute) {
            this.challenge = this.$store.state.selectedChallenge;
          } else {
            this.challenge = this.$store.state.lastChallenge;
          }
          this.lesson = this.challenge.lessons[this.lessonNumber - 1];
          this.mountSteps();
        })
        .catch();
    },
    goToLastCompletedStep() {
      // vamos ir direto para o step que ainda não foi completo.
      // ele marca o current step (key + 1)
      // e para no primeiro completed=false que encontrar
      // console.log(this.steps.map(step => console.log(step)));
      const allStepsCompleted = !this.steps.some((step, key) => {
        this.step = key + 1;
        return step.completed == false;
      });

      // se todos steps foram completos, vamos para o primeiro.
      if (allStepsCompleted) this.step = 1;
    }
  },
  mounted() {
    this.challengeIdFromRoute = this.$route.params.challengeId;
    this.lessonNumber = this.$route.params.number;

    // vamos setar o path se for de rota.
    if (this.challengeIdFromRoute) {
      this.urlPath = `/desafio/${this.challengeIdFromRoute}`;
      this.actionName = "fetchSelectedChallenge";
    }

    this.updateLesson().then(() => {
      this.goToLastCompletedStep();
    });
  }
};
</script>
